import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 5.333c0-.368.298-.666.667-.666H10A.667.667 0 1 1 10 6H8.667A.667.667 0 0 1 8 5.333M8.667 7.333a.667.667 0 0 0 0 1.334H10a.667.667 0 1 0 0-1.334z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 2a1.333 1.333 0 0 0-1.333 1.333v9.334A1.333 1.333 0 0 0 4 14h7.333a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm2.667 10.667h4.666A.667.667 0 0 0 12 12V4a.667.667 0 0 0-.667-.667H6.667zm-1.334 0V3.333H4v9.334z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })